import { render, staticRenderFns } from "./CustomLanguageSelect.vue?vue&type=template&id=6894bc16"
import script from "./CustomLanguageSelect.vue?vue&type=script&lang=ts"
export * from "./CustomLanguageSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6894bc16')) {
      api.createRecord('6894bc16', component.options)
    } else {
      api.reload('6894bc16', component.options)
    }
    module.hot.accept("./CustomLanguageSelect.vue?vue&type=template&id=6894bc16", function () {
      api.rerender('6894bc16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomLanguageSelect.vue"
export default component.exports